import React, { useState, useEffect } from 'react';
import {
  Grid,
  Menu,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  Box,
  Button,
  Card,
  Select,
  Icon,
} from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import SimpleFooter from "examples/Footers/SimpleFooter";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import routes from "trainingCompanyRoutes";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import moment from 'moment-timezone';
import MKInput from 'components/MKInput';
import Breadcrumbs from "examples/Breadcrumbs";
import CountryList from 'country-list-with-dial-code-and-flag';
import MKAvatar from "components/MKAvatar";
import deleteIcon from "assets/images/icons8-delete-48.png";
import add from "assets/images/icons8-add-67.png";
import AWS from 'aws-sdk';
import {
  GetCountries,
  GetState,
  GetCity,
} from "react-country-state-city";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              height: 'auto',
              p: 2,
              mx: { xs: 2, lg: 3 },
              mt: -8,
              mb: 4,
              backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

const Page = () => {
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const [headQuartersLocation, setHeadQuartersLocation] = useState("");
  const [headQuartersCountry, setHeadQuartersCountry] = useState("");
  const [trainingsOffered, setTrainingsOffered] = useState([]);
  const [otherLocations, setOtherLocations] = useState("");
  const [dateOfCompanyRegistration, setDateOfCompanyRegistration] = useState("");
  const [clients, setClients] = useState([]);
  const [timeZoneOpen, setTimeZoneOpen] = useState(false);
  const [trainingsOfferedOpen, setTrainingsOfferedOpen] = useState(false);
  const [personalSelectedCountry, setPersonalSelectedCountry] = useState("");
  const [clientOpen, setClientOpen] = useState(false);
  const [mobNumber, setMobNumber] = useState("");
  const [emailID, setEmailId] = useState("");
  const [profileDescription, setProfileDescription] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [s3BucketURL, setS3BucketURL] = useState(null);
  const [paymentTerms, setPaymentTerms] = useState("");
  const [GSTNumber, setGSTNumber] = useState("");
  const [emergencyNumber, setEmergencyNumber] = useState("");
  const [selectedEmgContactCountry, setSelectedEmgContactCountry] = useState('');
  const [emgContactCountryCode, setEmgContactCountryCode] = useState('');
  const [selectedSecContactCountry, setSelectedSecContactCountry] = useState('');
  const [secContactCountryCode, setSecContactCountryCode] = useState('');
  const [panNumber, setPanNumber] = useState("");

  const [companyName, setCompanyName] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const [submitCompleted, setSubmitCompleted] = useState(false);

  const [salutation, setSalutation] = useState(null);
  const [salutationDropdown, setSalutationDropdown] = useState(null);
  const [emgSalutation, setEmgSalutation] = useState(null);
  const [emgSalutationDropdown, setEmgSalutationDropdown] = useState(null);
  const [firstNameError, setFirstNameError] = useState(true);
  const [lastNameError, setLastNameError] = useState(true);
  const [emgFirstNameError, setEmgFirstNameError] = useState(true);
  const [emgLastNameError, setEmgLastNameError] = useState(true);
  const [locationError, setLocationError] = useState(true);
  const [secondaryNumberError, setSecondaryNumberError] = useState(true);
  const [emergencyNumberError, setEmergencyNumberError] = useState(true);
  const [aadharNumberError, setAadharNumberError] = useState(true);
  const [panNumberError, setPanNumberError] = useState(true);
  const [passportNumberError, setPassportNumberError] = useState(true);
  const [paymentTermsError, setPaymentTermsError] = useState(true);
  const [GSTNumberError, setGSTNumberError] = useState(true);
  const [isFieldProfileInteracted, setIsFieldProfileInteracted] = useState(false);
  const [skillsName, setSkillsName] = useState([]);
  const [clientName, setClientName] = useState([]);
  const [loading, setLoading] = useState(false);
  const [profilePictureError, setProfilePictureError] = useState(null);
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');

  const [bbdata, setbbdata] = useState([]);
  const [userId, setUserId] = useState("");

  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([])
  const [countryID, setCountryID] = useState(0);
  const [generalInformationCompleted, setGeneralInformationCompleted] = useState(false);
  const [emergencyContactDetailsCompleted, setEmergencyContactDetailsCompleted] = useState(false);
  const [headQuarterCompleted, setHeadQuarterCompleted] = useState(false);

  useEffect(() => {
    GetCountries().then((result) => {
      setCountryList(result);
    });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setSkillsName(["N/A", ...data]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("skillsName", skillsName);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/client-details/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setClientName(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("clientName", clientName);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    setUserId(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setbbdata(data);
          setMobNumber(data.mobile_number);
          setEmailId(data.email);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("token")]);
  console.log(bbdata);

  const [timeZone, setTimeZone] = useState([
    {
      workingTimeZone: "",
    },
  ]);

  const [address, setAddress] = useState([
    {
      trainingCompanyProfileID: '',
      addressLine1: '',
      addressLine2: '',
      country: '',
      city: '',
      state: '',
      pincode: '',
    },
  ]);

  const today = new Date().toISOString().split('T')[0];

  const [personalAddress, setPersonalAddress] = useState([
    {
      trainingCompanyProfileID: '',
      addressLine1: '',
      addressLine2: '',
      country: '',
      city: '',
      state: '',
      pincode: '',
    },
  ]);

  const [personalDetails, setPersonalDetails] = useState([
    {
      trainingCompanyProfileID: '',
      GSTNumber: '',
      panNumber: '',
      paymentTerms: '',
    },
  ]);

  const [languages, setLanguages] = useState([
    { language: '', read: false, write: false, speak: false },
  ]);

  const [visaInfo, setVisaInfo] = useState([
    {
      country: "",
      fromDate: "",
      toDate: "",
    },
  ]);

  const [jobProfiles, setJobProfiles] = useState([
    {
      companyName: '',
      designation: '',
      technology: '',
      employmentType: '',
      dateOfJoining: '',
      dateOfLeaving: '',
      jobProfile: '',
    },
  ]);

  const [consulting, setConsulting] = useState([
    { projectTitle: '', projectDescription: '' },
  ]);

  const [commercial, setCommercial] = useState({
    forLessThan4hrs: '',
    for4hrs: '',
    for8hrs: '',
  });

  const [trainingExperience, setTrainingExperience] = useState({
    trainingTechnology: '',
    clientDelivered: '',
    totalNoOfTrainings: '',
    dateOfLastTraining: '',
    totalTrainingExperience: '',
    deliveryMethod: '',
    demoLink: '',
    consulting: consulting,
    commercial: commercial,
  });

  const [educationList, setEducationList] = useState([
    {
      education: "",
      university: "",
      course: "",
      specialization: "",
      courseTime: "",
      mark: "",
      fromYear: "",
      toYear: "",
    },
  ]);

  const [certificationList, setCertificationList] = useState([
    {
      certificationName: "",
      certificationId: "",
      url: "",
      certificateNeverExpires: false,
      certificationFromYear: "",
      certificationToYear: "",
    },
  ]);

  console.log("userid", userId);

  const [emgContactDetails, setEmgContactDetails] = useState([
    {
      trainingCompanyProfileID: "",
      emgSalutation: "",
      emgFirstName: "",
      emgLastName: "",
      emgContactCountryCode: "",
      emgNumber: "",
    },
  ]);

  const [contactDetails, setContactDetails] = useState([
    {
      trainingCompanyProfileID: "",
      salutation: "",
      firstName: "",
      lastName: "",
      secContactCountryCode: "",
      secondaryNumber: "",
    },
  ]);

  const socialMediaPlatforms = [
    { label: "LinkedIn", name: "linkedInUrl" },
    { label: "Facebook", name: "facebookUrl" },
    { label: "Twitter", name: "twitterUrl" },
    { label: "Instagram", name: "instagramUrl" },
    { label: "Youtube", name: "youtubeUrl" },
  ];

  const [socialMediaUrls, setSocialMediaUrls] = useState({
    facebookUrl: "",
    twitterUrl: "",
    linkedInUrl: "",
    instagramUrl: "",
    youtubeUrl: "",
  });

  const [trainingExpInfoValid, setTrainingExpInfoValid] = useState(false);
  const TrainingExpInfoAllFieldsFilled = () => {
    const allFieldsFilled =
      trainingExperience.trainingTechnology &&
      trainingExperience.clientDelivered &&
      trainingExperience.totalNoOfTrainings &&
      trainingExperience.dateOfLastTraining &&
      trainingExperience.totalTrainingExperience &&
      trainingExperience.deliveryMethod &&
      consulting.every((project) => project.projectTitle && project.projectDescription) &&
      commercial.forLessThan4hrs &&
      commercial.for4hrs &&
      commercial.for8hrs;
    setTrainingExpInfoValid(allFieldsFilled);
  };

  useEffect(() => {
    TrainingExpInfoAllFieldsFilled();
  }, [
    trainingExperience.trainingTechnology,
    trainingExperience.clientDelivered,
    trainingExperience.totalNoOfTrainings,
    trainingExperience.dateOfLastTraining,
    trainingExperience.totalTrainingExperience,
    trainingExperience.deliveryMethod,
    consulting,
    commercial,
  ]);

  const handleMenuItemClick = (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    if (menuItem === 'GeneralInformation') {
      setCurrentStep(1);
    } else if (menuItem === 'EmergencyContactDetails') {
      setCurrentStep(2);
    } else if (menuItem === 'AdditionalContactDetails') {
      setCurrentStep(3);
    } else if (menuItem === 'HeadQuarters') {
      setCurrentStep(4);
    } else if (menuItem === 'BranchAddress') {
      setCurrentStep(5);
    } else if (menuItem === 'CompanyInformation') {
      setCurrentStep(6);
    } else if (menuItem === 'SocialMedia') {
      setCurrentStep(7);
    }
  };

  const [isNewContactAdded, setIsNewContactAdded] = useState(false);

  const handleAddContact = () => {
    const newContact = {
      trainingCompanyProfileID: userId,
      salutation: "",
      firstName: "",
      lastName: "",
      secContactCountryCode: "",
      secondaryNumber: "",
    };
    setContactDetails(prevDetails => [...prevDetails, newContact]);
    setIsNewContactAdded(true);
  };

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_S3_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_S3_AWS_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_S3_REGION,
  });

  useEffect(() => {
    let userName = localStorage.getItem("user");
    let id = localStorage.getItem("userId");
    let bucketURL = `trainingcompanyhub/${id}_${userName}`;
    setS3BucketURL(bucketURL);
  }, [])

  console.log("s3bucketurl", s3BucketURL);

  const [svgSelectedFile1, setSvgSelectedFile1] = useState(null);
  const [svgSelectedFile2, setSvgSelectedFile2] = useState(null);

  const handleProfilePictureChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const fileExtension = selectedFile.name.split('.').pop();
      const allowedFormats = ['jpeg', 'jpg', 'png',];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        setProfilePictureError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 300 * 1024) {
        setProfilePictureError("File size should be maximum 300kb.");
        return;
      }
      setProfilePictureError(null);

      const renamedFile = new File([selectedFile], `company-logo.${fileExtension}`, { type: selectedFile.type });
      setProfilePicFile(renamedFile);

      const reader = new FileReader();
      reader.onload = (e) => {
        setProfilePicture(e.target.result);
        setAvatarBackgroundColor('transparent');
        convertImageToSvg(e.target.result, renamedFile);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const convertImageToSvg = (imageData, profilePicFile) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      const dataURL = canvas.toDataURL('image/png');
      const svgString = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="${img.width}" height="${img.height}">
                          <image xlink:href="${dataURL}" width="${img.width}" height="${img.height}" />
                        </svg>`;
      setSvgSelectedFile2(svgString);
    };

    img.onerror = (error) => {
      console.error('Error loading image:', error);
    };

    img.src = imageData;
  };

  console.log("svgSelectedFile1", svgSelectedFile1);
  console.log("svgSelectedFile2", svgSelectedFile2);

  console.log("profilePicture", profilePicture);
  console.log("profilePicFile", profilePicFile);

  const handleDeleteContact = (index) => {
    const updatedcontact = [...contactDetails];
    updatedcontact.splice(index, 1);
    setContactDetails(updatedcontact);
    if (index - 1 === 0 && updatedcontact.length < 1) {
      setIsNewContactAdded(false);
    }
  };

  console.log("contactDetails", contactDetails);

  console.log("companyName", companyName);
  console.log("headQuartersCountry", headQuartersCountry);
  console.log("headQuartersLocation", headQuartersLocation);
  console.log("otherLocations", otherLocations);

  const options = Array.from({ length: 16 }, (_, index) => index);

  const handleClientsChange = (event, newValue) => {
    const typedClient = event.target.value;
    console.log("typedClient@@@@@@@@@@@@@", typedClient);
    if (typedClient && !clientName.includes(typedClient)) {
      fetch(`${process.env.REACT_APP_API_URL}/api/client-details/?q=${typedClient}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setClientName([...clientName, ...data]);
        })
        .catch((error) => {
          console.error(error);
        });
    }
    const formattedClients = newValue.join(', ');
    setClients(formattedClients);
    setClientOpen(false);
  };
  console.log("clients", clients);

  const handleTrainingsOfferedChange = (event, newValue) => {
    const typedSkill = event.target.value;
    console.log("typedSkill@@@@@@@@@@@@@", typedSkill);
    if (typedSkill && !skillsName.includes(typedSkill)) {
      fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/?q=${typedSkill}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setSkillsName([...skillsName, ...data]);
        })
        .catch((error) => {
          console.error(error);
        });
    }
    const formattedTraining = newValue.join(', ');
    setTrainingsOffered(formattedTraining);
    setTrainingsOfferedOpen(false);
  };
  console.log("trainingsOffered", trainingsOffered);

  const timeZones = moment.tz.names();

  const handleTimeZoneChange = (newValue) => {
    const formattedTimeZones = newValue.join(', ');
    setTimeZone(formattedTimeZones);
    setTimeZoneOpen(false);
  };

  const handleDateOfCompanyRegistrationChange = (e) => {
    setDateOfCompanyRegistration(e.target.value);
  };
  console.log("dateOfCompanyRegistration", dateOfCompanyRegistration);

  const handleProfileChange = (e) => {
    setProfileDescription(e.target.value);
  };
  console.log("profileDescription", profileDescription);

  const [isNewAddressAdded, setIsNewAddressAdded] = useState(false);

  const handleAddAddress = () => {
    setPersonalAddress((prevAddresses) => [
      ...prevAddresses,
      {
        trainingCompanyProfileID: userId,
        addressLine1: '',
        addressLine2: '',
        country: '',
        city: '',
        state: '',
        pincode: '',
      },
    ]);
    setIsNewAddressAdded(true);
  };

  const handleDeleteAddress = (index) => {
    const updatedaddress = [...personalAddress];
    updatedaddress.splice(index, 1);
    setPersonalAddress(updatedaddress);
    if (index - 1 === 0 && updatedaddress.length < 1) {
      setIsNewAddressAdded(false);
    }
  };

  const handlePersonalAddressChange = (event, index) => {
    const { name, value } = event.target;
    setPersonalAddress((prevAddresses) => {
      const newAddresses = [...prevAddresses];
      if (index === 0) {
        newAddresses[index] = {
          ...newAddresses[index],
          trainingCompanyProfileID: userId
        };
      }
      newAddresses[index][name] = value;
      return newAddresses;
    });
  };


  const handlePersonalAddressCountryChange = (event, index) => {
    const { value } = event.target;

    setPersonalAddress((prevAddresses) => {
      const newAddresses = prevAddresses.map((address, idx) =>
        idx === index ? { ...address, country: value, state: '', city: '' } : address
      );
      return newAddresses;
    });

    const selectedCountry = countryList.find((country) => country.name === value);
    if (selectedCountry) {
      setCountryID(selectedCountry.id);

      GetState(selectedCountry.id).then((result) => {
        setStateList(result);
      });
    }
  };

  const handleBranchStateChange = (event, index) => {
    const { value } = event.target;

    setPersonalAddress((prevAddresses) => {
      const newAddresses = prevAddresses.map((address, idx) =>
        idx === index ? { ...address, state: value, city: '' } : address
      );
      return newAddresses;
    });

    const selectedState = stateList.find((state) => state.name === value);
    if (selectedState) {
      GetCity(countryID, selectedState.id).then((result) => {
        setCityList(result);
      });
    }
  };

  const handleBranchCityChange = (event, index) => {
    const { value } = event.target;

    setPersonalAddress((prevAddresses) => {
      const newAddresses = prevAddresses.map((address, idx) =>
        idx === index ? { ...address, city: value } : address
      );
      return newAddresses;
    });
  };


  console.log("personalSelectedCountry", personalSelectedCountry);
  console.log("personalAddress", personalAddress);

  const [isAddressFilled, setIsAddressFilled] = useState({
    addressLine1: false,
    addressLine2: false,
    country: false,
    state: false,
    city: false,
    pincode: false
  });

  const handleAddressCountryChange = (event) => {
    const selectedCountryIndex = event.target.value;
    const selectedCountry = countryList[selectedCountryIndex];

    setAddress(prevState => [{ ...prevState[0], country: selectedCountry.name }]);
    setIsAddressFilled(prevState => ({ ...prevState, country: !!selectedCountry.name }));

    setCountryID(selectedCountry.id);

    GetState(selectedCountry.id).then((result) => {
      setStateList(result);
    });
  };

  const handleStateChange = (event) => {
    const selectedStateIndex = event.target.value;
    const selectedState = stateList[selectedStateIndex];

    setAddress(prevState => [{ ...prevState[0], state: selectedState.name }]);
    setIsAddressFilled(prevState => ({ ...prevState, state: !!selectedState.name }));

    GetCity(countryID, selectedState.id).then((result) => {
      setCityList(result);
    });
  };

  const handleCityChange = (event) => {
    const selectedCityIndex = event.target.value;
    const selectedCity = cityList[selectedCityIndex];
    setAddress(prevState => [{ ...prevState[0], city: selectedCity.name }]);
    setIsAddressFilled(prevState => ({ ...prevState, city: !!selectedCity.name }));
  };


  const handleAddressChange = (event) => {
    const { name, value } = event.target;
    const alphabetsRegex = /^[A-Za-z]*$/;
    const numbersRegex = /^[0-9]*$/;

    if (name === 'city' && !alphabetsRegex.test(value)) return;
    if (name === 'district' && !alphabetsRegex.test(value)) return;
    if (name === 'state' && !alphabetsRegex.test(value)) return;
    if (name === 'pincode' && !numbersRegex.test(value)) return;

    setAddress(prevState => [{ ...prevState[0], [name]: value }]);
    setIsAddressFilled(prevState => ({ ...prevState, [name]: !!value }));

    setAddress(prevState => [{ ...prevState[0], trainingCompanyProfileID: userId }]);
  };

  console.log("hqaddress", address);

  const handleContactDetailsFristNameChange = (index, e) => {
    const input = e.target.value;
    const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]/;
    const isValid = !regex.test(input);
    setFirstNameError(isValid);
    setContactDetails(prevDetails => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index].firstName = input;
      return updatedDetails;
    });
    setContactDetails(prevDetails => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index].trainingCompanyProfileID = userId;
      return updatedDetails;
    });
  };

  const handleEmgFirstNameChange = (e) => {
    const input = e.target.value;
    const regex = /^[A-Za-z]+$/;
    const isValid = regex.test(input);
    setEmgFirstNameError(isValid);
    setIsEmgContactDetailsFilled(prevState => ({ ...prevState, emgFirstName: !!input }));
    updateEmgContactDetails({ emgFirstName: input });
  };

  const handleEmgLastNameChange = (e) => {
    const input = e.target.value;
    const regex = /^[A-Za-z]+$/;
    const isValid = regex.test(input);
    setEmgLastNameError(isValid);
    setIsEmgContactDetailsFilled(prevState => ({ ...prevState, emgLastName: !!input }));
    updateEmgContactDetails({ emgLastName: input });
  };

  const handleEmgContactCountryChange = (event) => {
    const selectedCountry = event.target.value;
    setSelectedEmgContactCountry(selectedCountry);
    setIsEmgContactDetailsFilled(prevState => ({ ...prevState, selectedEmgContactCountry: !!selectedCountry }));
    const country = CountryList.getAll().find((c) => c.name === selectedCountry);
    if (country) {
      setEmgContactCountryCode(country.dialCode);
      updateEmgContactDetails({ emgContactCountryCode: country.dialCode });
    }
    updateEmgContactDetails({ trainingCompanyProfileID: userId });
  };

  const handleEmergencyNumberChange = (e, setValidation) => {
    const input = e.target.value;
    const regex = /^[0-9+-]+$/;
    const isValid = regex.test(input);
    setEmergencyNumberError(isValid);
    setIsEmgContactDetailsFilled(prevState => ({ ...prevState, emergencyNumber: !!input }));
    updateEmgContactDetails({ emgNumber: input });
  };

  const updateEmgContactDetails = (updatedData) => {
    setEmgContactDetails((prevDetails) => {
      const updatedDetails = { ...prevDetails[0], ...updatedData };
      return [updatedDetails];
    });
  };

  console.log("emgContactDetails", emgContactDetails);


  const handlePaymentTermsChange = (e, setValidation) => {
    const input = e.target.value;
    const regex = /^[0-9]+$/;
    const isValid = input === '' || regex.test(input);
    setPaymentTermsError(isValid);

    setPersonalDetails(prevState => [{ ...prevState[0], trainingCompanyProfileID: userId }]);
    setPersonalDetails(prevState => [{ ...prevState[0], paymentTerms: e.target.value }]);
  };

  const handlePanNumberChange = (e, setValidation) => {
    const input = e.target.value;
    const regex = /^[A-Z]{5}\d{4}[A-Z]$/;
    const isValid = input === '' || regex.test(input);
    setPanNumberError(isValid);

    setPersonalDetails(prevState => [{ ...prevState[0], trainingCompanyProfileID: userId }]);
    setPersonalDetails(prevState => [{ ...prevState[0], panNumber: e.target.value }]);
  };

  const handleGSTNumberChange = (e, setValidation) => {
    const input = e.target.value;
    const regex = /^[0-9]+$/;
    const isValid = input === '' || regex.test(input);
    setGSTNumberError(isValid);

    setPersonalDetails(prevState => [{ ...prevState[0], trainingCompanyProfileID: userId }]);
    setPersonalDetails(prevState => [{ ...prevState[0], GSTNumber: e.target.value }]);

  };

  const handleSocialMediaUrlChange = (name, value) => {
    setSocialMediaUrls((prevUrls) => ({
      ...prevUrls,
      [name]: value,
    }));
  };

  console.log("socialMediaUrls", socialMediaUrls);

  const openEmgSalutationDropdown = (event) => {
    setEmgSalutationDropdown(event.currentTarget);
  };

  const closeEmgSalutationDropdown = () => {
    setEmgSalutationDropdown(null);
  };

  const openSalutationDropdown = (event) => {
    setSalutationDropdown(event.currentTarget);
  };

  const closeSalutationDropdown = () => {
    setSalutationDropdown(null);
  };

  const handleSalutationSelect = (salutation, index) => {
    setContactDetails(prevDetails => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index].salutation = salutation;
      return updatedDetails;
    });
    setSalutation(salutation);
    console.log('Selected Salutation:', salutation);
    closeSalutationDropdown();
  };

  const [isEmgContactDetailsFilled, setIsEmgContactDetailsFilled] = useState({
    emgSalutation: false,
    emgFirstName: false,
    emgLastName: false,
    selectedEmgContactCountry: false,
    emergencyNumber: false
  });

  const handleEmgSalutationSelect = (salutation) => {
    setEmgSalutation(salutation);
    setIsEmgContactDetailsFilled(prevState => ({ ...prevState, emgSalutation: !!salutation }));
    console.log('Selected Salutation:', emgSalutation);
    closeEmgSalutationDropdown();
    updateEmgContactDetails({ emgSalutation: salutation });
  };

  const handleGeneralProfileNextClick = async (menuItem) => {
    setLoading(true);
    console.log("profilePicFile", profilePicFile);
    try {
      const data = {
        user_id: userId,
        companyName: companyName,
        // companyLogo: svgSelectedFile2,
        S3BucketURL: s3BucketURL,
        clients: clients,
        trainingOffered: trainingsOffered,
        companyRegistrationDate: dateOfCompanyRegistration,
        mobileNumber: mobNumber,
        email: emailID,
        supportedClientTimezone: timeZone,
        profile: profileDescription,
        socialMedia: socialMediaUrls,
        premiumStatus: "no",
        status: "Active",
        eventTrigger: "Application",
      };
      console.log(JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/training-companyprofile-details-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }

      console.log("picfile", profilePicFile);
      console.log("okresponse", response.ok);
      if (response.ok && profilePicFile) {
        const formData = new FormData();
        formData.append('files', profilePicFile);
        console.log("formData", formData);
        console.log("s3BucketURL", s3BucketURL);
        fetch(`${process.env.REACT_APP_API_URL}/api/upload/${s3BucketURL}/company-logo/`, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error('Error uploading file:', error);
          });
        console.log("Profile pic uploaded successfully");
      }
      else {
        console.error("File input not found or no file selected");
        setSubmitCompleted(false);
      }
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setGeneralInformationCompleted(true);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const onSubmitClick = async (e) => {
    setLoading(true);
    try {
      const data = {
        socialMedia: socialMediaUrls,
        eventTrigger: "Application",
      };
      console.log(JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tcp-social-create/${userId}/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }

      setSubmitCompleted(true);
      setLoading(false);
      console.log("Profile created successfully");
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };


  const handleOtpSubmit = () => {
    const data = {
      mobile_number: mobNumber,
      otp: otpValue,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/verify-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setOtpSent(false);
        }
        return response.json();
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo");
      });
  };

  const DialogClose = () => {
    setOtpSent(false);
  };

  const DialogProfileClose = () => {
    window.location.href = '/app/trainingcompanydashboard';
  };
  const [currentStep, setCurrentStep] = useState(1);

  console.log("contactDetails", contactDetails);


  const handleBackClick = (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const sidebarStyles = {
    width: '250px',
    padding: '20px',
    color: 'white',
    borderRadius: '15px',
  };

  const handleCompanyInfoSkipClick = async (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleAdditionalContactSkipClick = async (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleBranchAddressSkipClick = async (menuItem) => {
    setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleEmgContactNextClick = async (menuItem) => {
    setLoading(true);
    try {
      const data = {
        tcpEmergencyContact: emgContactDetails,
        eventTrigger: "Application",
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tcp-emergencycontact-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setEmergencyContactDetailsCompleted(true);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handleCompanyInfoNextClick = async (menuItem) => {
    setLoading(true);
    try {
      const data = {
        tcpPersonalDetails: personalDetails,
        eventTrigger: "Application",
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tcp-personaldetails-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handleAdditionalContactNextClick = async (menuItem) => {
    setLoading(true);
    try {
      const data = {
        tcpAdditionalContactDetails: contactDetails,
        eventTrigger: "Application",
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tcp-additionalcontact-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  const handleBranchAddressNextClick = async (menuItem) => {
    setLoading(true);
    try {
      const data = {
        tcpBranchAddress: personalAddress,
        eventTrigger: "Application",
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tcp-branchaddress-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };


  const handleHeadQuartersNextClick = async (menuItem) => {
    setLoading(true);
    try {
      const data = {
        tcpHQAddress: address,
        eventTrigger: "Application",
      };
      console.log("jsondata", JSON.stringify(data));
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/tcp-hqaddress-create/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Profile is not created. Something went wrong");
      }
      setActiveMenuItem(activeMenuItem === menuItem ? null : menuItem);
      setCurrentStep((prevStep) => prevStep + 1);
      setHeadQuarterCompleted(false);
      setLoading(false);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitCompleted(false);
    }
  };

  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={routes}
          sticky
        />
        <Card
          sx={{
            minHeight: '101vh',
            height: 'auto',
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Container>
            <Grid container>
              <Grid item xs={3} style={{ marginTop: "120px" }}>
                <div>
                  <Dialog
                    open={otpSent}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification! Please enter the OTP you have received
                    </DialogTitle>
                    <DialogContent>
                      <div>
                        <InputLabel>Enter OTP</InputLabel>
                        <TextField
                          variant="outlined"
                          value={otpValue}
                          onChange={(e) => setOtpValue(e.target.value)}
                        />
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleOtpSubmit} color="primary" autoFocus>
                        Submit OTP
                      </Button>
                      <Button onClick={DialogClose} color="primary">
                        Cancel
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Congratulations!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your profile is now officially live. Let the world discover the amazing you!
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <MKButton onClick={() => { setSubmitCompleted(false); DialogProfileClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Grid item xs={9}>
                    <div style={sidebarStyles}>
                      <MenuItem
                        onClick={() => handleMenuItemClick('GeneralInformation')}
                        style={activeMenuItem === 'GeneralInformation' || currentStep === 1 ? { fontWeight: 'bold' } : {}}
                      >
                        General Information
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('EmergencyContactDetails')}
                        style={activeMenuItem === 'EmergencyContactDetails' || currentStep === 2 ? { fontWeight: 'bold' } : {}}
                        // disabled={generalInformationCompleted === false}
                      >
                        Emergency Contact Details
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('AdditionalContactDetails')}
                        style={activeMenuItem === 'AdditionalContactDetails' || currentStep === 3 ? { fontWeight: 'bold' } : {}}
                        // disabled={generalInformationCompleted === false || emergencyContactDetailsCompleted === false}
                      >
                        Additional Contact Details
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('HeadQuarters')}
                        style={activeMenuItem === 'HeadQuarters' || currentStep === 4 ? { fontWeight: 'bold' } : {}}
                        // disabled={generalInformationCompleted === false || emergencyContactDetailsCompleted === false}
                      >
                        Head Quarters
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('BranchAddress')}
                        style={activeMenuItem === 'BranchAddress' || currentStep === 5 ? { fontWeight: 'bold' } : {}}
                        // disabled={generalInformationCompleted === false || emergencyContactDetailsCompleted === false || headQuarterCompleted === false}
                      >
                        Branch Address
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('CompanyInformation')}
                        style={activeMenuItem === 'CompanyInformation' || currentStep === 6 ? { fontWeight: 'bold' } : {}}
                        // disabled={generalInformationCompleted === false || emergencyContactDetailsCompleted === false || headQuarterCompleted === false}
                      >
                        Company Information
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMenuItemClick('SocialMedia')}
                        style={activeMenuItem === 'SocialMedia' || currentStep === 7 ? { fontWeight: 'bold' } : {}}
                        // disabled={generalInformationCompleted === false || emergencyContactDetailsCompleted === false || headQuarterCompleted === false}
                      >
                        Social Media
                      </MenuItem>
                    </div>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={9} style={{ marginTop: "160px" }}>
                {currentStep === 1 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>General Information</Typography>
                    <div>
                      <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                        <div>
                          <MKAvatar
                            src={profilePicture}
                            alt="Profile Picture"
                            size="xl"
                            style={{ backgroundColor: avatarBackgroundColor }}
                          />
                        </div>
                        <div>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleProfilePictureChange}
                            style={{ display: 'none' }}
                            id="profile-picture-input"
                          />
                          <label htmlFor="profile-picture-input">
                            <MKButton variant="gradient" color="info" component="span" size="small">
                              Upload Logo *&nbsp;&nbsp;<Icon>cloud_upload</Icon>
                            </MKButton>
                          </label>
                        </div>
                      </div>
                      {profilePictureError && (
                        <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                          {profilePictureError}
                        </MKTypography>
                      )}
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <TextField
                            label="Company Name *"
                            variant="outlined"
                            style={{ width: "250px" }}
                            fullWidth
                            value={companyName}
                            onChange={(e) => {
                              setCompanyName(e.target.value);
                            }}
                          />
                        </div>
                        <div>
                          <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>Company Registration Date</InputLabel>
                          <MKInput
                            type="date"
                            id="date_ofCompanyRegistration"
                            value={dateOfCompanyRegistration || ""}
                            onChange={handleDateOfCompanyRegistrationChange}
                            style={{ width: "250px" }}
                            placeholder="Date of Company Registration"
                            inputProps={{ max: today }}
                            disabled={loading}
                          />
                        </div>
                      </div>

                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <TextField
                            label="Mobile Number *"
                            variant="outlined"
                            style={{ width: "250px" }}
                            value={mobNumber}
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                          />
                        </div>
                        <div>
                          <TextField
                            label="Email Id *"
                            variant="outlined"
                            style={{ width: "250px" }}
                            value={emailID}
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <Autocomplete
                            multiple
                            id="clients-autocomplete"
                            options={clientName}
                            freeSolo
                            renderTags={(value, getTagProps) =>
                              value.map((option, tagIndex) => (
                                <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                                  {option}
                                </span>
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Clients *"
                                variant="outlined"
                                style={{ width: '520px' }}
                                helperText="Select one or more clients by typing or choosing from the dropdown."
                                fullWidth
                              />
                            )}
                            onChange={(event, value) => handleClientsChange(event, value)}
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <Autocomplete
                            multiple
                            id="skills-autocomplete"
                            options={skillsName}
                            freeSolo
                            renderTags={(value, getTagProps) =>
                              value.map((option, tagIndex) => (
                                <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                                  {option}
                                </span>
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Trainings Offered *"
                                variant="outlined"
                                style={{ width: '520px' }}
                                helperText="Select one or more technology by typing or choosing from the dropdown."
                                fullWidth
                              />
                            )}
                            onChange={(event, value) => handleTrainingsOfferedChange(event, value)}
                          />
                        </div>
                      </div>
                      <div>
                        <Autocomplete
                          multiple
                          id="timeZone-autocomplete"
                          options={timeZones}
                          freeSolo
                          renderTags={(value, getTagProps) =>
                            value.map((option, tagIndex) => (
                              <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                                {option}
                              </span>
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Working Time Zone *"
                              variant="outlined"
                              style={{ width: '520px' }}
                              helperText="Select one or more time zone by typing or choosing from the dropdown."
                              fullWidth
                            />
                          )}
                          onChange={(event, value) => handleTimeZoneChange(value)}
                        />
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <TextField
                            label="Profile (A brief introduction about yourself, 100 to 1000 characters)*"
                            multiline
                            rows={4}
                            variant="outlined"
                            style={{
                              width: "520px",
                              borderColor: profileDescription.length >= 100 && profileDescription.length <= 1000 && isFieldProfileInteracted
                                ? "initial"
                                : "initial",
                            }}
                            fullWidth
                            error={isFieldProfileInteracted && (profileDescription.length < 100 || profileDescription.length > 1000)}
                            helperText={
                              isFieldProfileInteracted && (profileDescription.length < 100 || profileDescription.length > 1000)
                                ? ""
                                : ""
                            }
                            value={profileDescription}
                            onChange={handleProfileChange}
                            onFocus={() => setIsFieldProfileInteracted(true)}
                          />
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-50px", marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" disabled={!companyName || !dateOfCompanyRegistration || !clients || !trainingsOffered || !timeZone
                        || !mobNumber || !emailID || !profilePicture || !profileDescription || profilePictureError || !(profileDescription.length >= 100 && profileDescription.length <= 1000)}
                        onClick={handleGeneralProfileNextClick} >NEXT</MKButton>
                    </div>
                  </div>
                )}
                {currentStep === 2 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Emergency Contact Details</Typography>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <Grid item xs={12}>
                        <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Emergency Contact Details</span> }]} />
                      </Grid>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <div>
                        <MKButton variant="gradient" color="info" onClick={openEmgSalutationDropdown}>
                          {emgSalutation || 'Salutation *'} <Icon>expand_more</Icon>
                        </MKButton>
                        <Menu anchorEl={emgSalutationDropdown} open={Boolean(emgSalutationDropdown)} onClose={closeEmgSalutationDropdown}>
                          <MenuItem onClick={() => handleEmgSalutationSelect('Mr.')}>Mr.</MenuItem>
                          <MenuItem onClick={() => handleEmgSalutationSelect('Mrs.')}>Mrs.</MenuItem>
                          <MenuItem onClick={() => handleEmgSalutationSelect('Miss.')}>Miss.</MenuItem>
                          <MenuItem onClick={() => handleEmgSalutationSelect('Ms.')}>Ms.</MenuItem>
                        </Menu>
                      </div>
                      <div>
                        <TextField
                          label="First Name *"
                          variant="outlined"
                          style={{ width: "250px", borderColor: emgFirstNameError ? 'red' : undefined }}
                          fullWidth
                          value={emgContactDetails.emgFirstName}
                          onChange={handleEmgFirstNameChange}
                          error={!emgFirstNameError}
                        />
                      </div>
                      <div>
                        <TextField
                          label="Last Name *"
                          variant="outlined"
                          style={{ width: "250px", borderColor: emgLastNameError ? 'red' : undefined }}
                          fullWidth
                          value={emgContactDetails.emgLastName}
                          onChange={handleEmgLastNameChange}
                          error={!emgLastNameError}
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <div>
                        <FormControl variant="outlined" style={{ width: '250px' }}>
                          <InputLabel id="EmergencyContactCountry">Emergency Contact Country *</InputLabel>
                          <Select
                            labelId="EmergencyContactCountry"
                            label="Emergency Contact Country"
                            fullWidth
                            onChange={handleEmgContactCountryChange}
                            value={selectedEmgContactCountry}
                            style={{ minHeight: '44px' }}
                          >
                            {CountryList.getAll().map((country) => (
                              <MenuItem key={country.name} value={country.name}>
                                {country.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div>
                        <TextField
                          label="Code *"
                          name="Code"
                          value={emgContactCountryCode}
                          InputProps={{
                            readOnly: true,
                          }}
                          style={{ width: '250px', minHeight: '44px' }}
                          fullWidth
                        />
                      </div>
                      <div>
                        <TextField
                          label="Emergency Contact Number *"
                          variant="outlined"
                          style={{ width: "250px", borderColor: emergencyNumberError ? 'red' : undefined }}
                          onChange={(e) => {
                            setEmergencyNumber(e.target.value);
                            handleEmergencyNumberChange(e, setEmergencyNumberError);
                          }}
                          error={!emergencyNumberError}
                          value={emergencyNumber}
                          fullWidth
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-50px", marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleEmgContactNextClick} disabled={!Object.values(isEmgContactDetailsFilled).every(Boolean)}>NEXT</MKButton>
                    </div>
                  </div>
                )}
                {currentStep === 3 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Additional Contact Details</Typography>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <Grid item xs={12}>
                        <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Additional Contact Details</span> }]} />
                      </Grid>
                    </div>
                    {contactDetails.map((contact, index) => (
                      <div key={index}>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <div>
                            <MKButton variant="gradient" color="info" onClick={openSalutationDropdown}>
                              {contact.salutation || 'Salutation'} <Icon>expand_more</Icon>
                            </MKButton>
                            <Menu anchorEl={salutationDropdown} open={Boolean(salutationDropdown)} onClose={closeSalutationDropdown}>
                              <MenuItem onClick={() => handleSalutationSelect('Mr.', index)}>Mr.</MenuItem>
                              <MenuItem onClick={() => handleSalutationSelect('Mrs.', index)}>Mrs.</MenuItem>
                              <MenuItem onClick={() => handleSalutationSelect('Miss.', index)}>Miss.</MenuItem>
                              <MenuItem onClick={() => handleSalutationSelect('Ms.', index)}>Ms.</MenuItem>
                            </Menu>
                          </div>
                          <div>
                            <TextField
                              label="First Name"
                              variant="outlined"
                              style={{ width: "250px", borderColor: firstNameError ? 'red' : undefined }}
                              fullWidth
                              value={contact.firstName}
                              onChange={(e) => handleContactDetailsFristNameChange(index, e)}
                              error={!firstNameError}
                            />
                          </div>
                          <div>
                            <TextField
                              label="Last Name"
                              variant="outlined"
                              style={{ width: "250px", borderColor: lastNameError ? 'red' : undefined }}
                              fullWidth
                              value={contact.lastName}
                              onChange={(e) => {
                                const input = e.target.value;
                                const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9]/;
                                const isValid = !regex.test(input);
                                setLastNameError(isValid);
                                setContactDetails(prevDetails => {
                                  const updatedDetails = [...prevDetails];
                                  updatedDetails[index].lastName = input;
                                  return updatedDetails;
                                });
                              }}
                              error={!lastNameError}
                            />
                          </div>
                          {isNewContactAdded && contactDetails.length >= 1 && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: "0px" }}>
                              <MKAvatar src={deleteIcon} alt="sm" size="sm" onClick={() => handleDeleteContact(index)} />
                            </div>
                          )}
                        </div>
                        <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <div>
                            <FormControl variant="outlined" style={{ width: '250px' }}>
                              <InputLabel id={`SecondaryContactCountry${index}`}>Secondary Contact Country</InputLabel>
                              <Select
                                labelId={`SecondaryContactCountry${index}`}
                                label="Secondary Contact Country"
                                fullWidth
                                onChange={(event) => {
                                  const selectedCountry = event.target.value;
                                  setSelectedSecContactCountry(selectedCountry);
                                  const country = CountryList.getAll().find((c) => c.name === selectedCountry);
                                  if (country) {
                                    setSecContactCountryCode(country.dialCode);
                                  }
                                  setContactDetails(prevDetails => {
                                    const updatedDetails = [...prevDetails];
                                    updatedDetails[index].secContactCountryCode = country.dialCode;
                                    return updatedDetails;
                                  });
                                }}
                                value={contact.selectedSecContactCountry}
                                style={{ minHeight: '44px' }}
                              >
                                {CountryList.getAll().map((country) => (
                                  <MenuItem key={country.name} value={country.name}>
                                    {country.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </div>
                          <div>
                            <TextField
                              label="Code"
                              name="Code"
                              value={contact.secContactCountryCode}
                              InputProps={{
                                readOnly: true,
                              }}
                              style={{ width: '250px', minHeight: '44px' }}
                              fullWidth
                            />
                          </div>
                          <div>
                            <TextField
                              label="Secondary Contact Number"
                              variant="outlined"
                              style={{ width: "250px", borderColor: secondaryNumberError ? 'red' : undefined }}
                              onChange={(e) => {
                                const input = e.target.value;
                                const regex = /^[0-9+-]+$/;
                                const isValid = regex.test(input);
                                setSecondaryNumberError(isValid);
                                setContactDetails(prevDetails => {
                                  const updatedDetails = [...prevDetails];
                                  updatedDetails[index].secondaryNumber = input;
                                  return updatedDetails;
                                });
                              }}
                              error={!secondaryNumberError}
                              value={contact.secondaryNumber}
                              fullWidth
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                    <div style={{ display: 'flex', marginBottom: "-30px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "-10px" }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <MKAvatar className="mk-avatar" style={{ cursor: 'pointer' }} src={add} alt="sm" size="sm" onClick={handleAddContact} />
                        <Typography variant='h6' className="add-text">&nbsp;Add More Contact Details</Typography>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-40px", marginBottom: "10px" }}>
                      {contactDetails.some(contact => Object.values(contact).some(value => value && value !== contact.trainingCompanyProfileID)) ? (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleAdditionalContactNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled >
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleAdditionalContactSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
                {currentStep === 4 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Head Quarters</Typography>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Head Quarters Address</span> }]} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="Address Line 1 *( Door No, Street Name )"
                            name="addressLine1"
                            value={address.addressLine1}
                            onChange={handleAddressChange}
                            style={{ minHeight: '44px' }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="Address Line 2 *( Area / Locality )"
                            name="addressLine2"
                            value={address.addressLine2}
                            onChange={handleAddressChange}
                            style={{ minHeight: '44px' }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <FormControl variant="outlined" style={{ width: '210px' }}>
                            <InputLabel id="country-select">Country *</InputLabel>
                            <Select
                              labelId="country"
                              label="Country"
                              fullWidth
                              onChange={handleAddressCountryChange}
                              value={countryList.findIndex((country) => country.name === address[0].country)}
                              style={{ minHeight: '44px' }}
                            >
                              {countryList.map((country, index) => (
                                <MenuItem key={index} value={index}>
                                  {country.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <FormControl variant="outlined" style={{ width: '210px' }}>
                            <InputLabel id="state-select">State *</InputLabel>
                            <Select
                              labelId="state"
                              label="State"
                              fullWidth
                              onChange={handleStateChange}
                              value={stateList.findIndex((state) => state.name === address[0].state)}
                              style={{ minHeight: '44px' }}
                            >
                              {stateList.map((state, index) => (
                                <MenuItem key={index} value={index}>
                                  {state.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <FormControl variant="outlined" style={{ width: '210px' }}>
                            <InputLabel id="city-select">City *</InputLabel>
                            <Select
                              labelId="city"
                              label="City"
                              fullWidth
                              onChange={handleCityChange}
                              value={cityList.findIndex((city) => city.name === address[0].city)}
                              style={{ minHeight: '44px' }}
                            >
                              {cityList.map((city, index) => (
                                <MenuItem key={index} value={index}>
                                  {city.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            label="Pincode / Zipcode *"
                            name="pincode"
                            value={address.pincode}
                            onChange={handleAddressChange}
                            style={{ minHeight: '44px' }}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    </div>
                    <div style={{ display: 'flex', marginBottom: "-30px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-40px", marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleHeadQuartersNextClick} disabled={!Object.values(isAddressFilled).every(Boolean)}>NEXT</MKButton>
                    </div>
                  </div>
                )}
                {currentStep === 5 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Branch Address</Typography>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Branch Address</span> }]} />
                        </Grid>
                        {personalAddress.map((address, index) => (
                          <React.Fragment key={index}>
                            <Grid item xs={12} md={5}>
                              <TextField
                                label="Address Line 1 ( Door No, Street Name )"
                                name="addressLine1"
                                value={address.addressLine1}
                                onChange={(event) => handlePersonalAddressChange(event, index)}
                                style={{ minHeight: '44px' }}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={12} md={5}>
                              <TextField
                                label="Address Line 2 ( Area / Locality )"
                                name="addressLine2"
                                value={address.addressLine2}
                                onChange={(event) => handlePersonalAddressChange(event, index)}
                                style={{ minHeight: '44px' }}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={12} md={2} container justifyContent="flex-end">
                              {isNewAddressAdded && personalAddress.length > 1 && (
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: "0px" }}>
                                  <MKAvatar src={deleteIcon} alt="sm" size="sm" onClick={() => handleDeleteAddress(index)} />
                                </div>
                              )}
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <FormControl variant="outlined" style={{ width: "210px" }}>
                                <InputLabel id={`country-select-${index}`}>Country</InputLabel>
                                <Select
                                  labelId={`country-${index}`}
                                  label="Country"
                                  fullWidth
                                  onChange={(event) => handlePersonalAddressCountryChange(event, index)}
                                  value={address.country}
                                  style={{ minHeight: "44px" }}
                                >
                                  {countryList.map((country) => (
                                    <MenuItem key={country.name} value={country.name}>
                                      {country.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <FormControl variant="outlined" style={{ width: "210px" }}>
                                <InputLabel id={`state-select-${index}`}>State</InputLabel>
                                <Select
                                  labelId={`state-${index}`}
                                  label="State"
                                  fullWidth
                                  onChange={(event) => handleBranchStateChange(event, index)}
                                  value={address.state}
                                  style={{ minHeight: "44px" }}
                                >
                                  {stateList.map((state) => (
                                    <MenuItem key={state.name} value={state.name}>
                                      {state.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <FormControl variant="outlined" style={{ width: "210px" }}>
                                <InputLabel id={`city-select-${index}`}>City</InputLabel>
                                <Select
                                  labelId={`city-${index}`}
                                  label="City"
                                  fullWidth
                                  onChange={(event) => handleBranchCityChange(event, index)}
                                  value={address.city}
                                  style={{ minHeight: "44px" }}
                                >
                                  {cityList.map((city) => (
                                    <MenuItem key={city.name} value={city.name}>
                                      {city.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <TextField
                                label="Pincode"
                                name="pincode"
                                value={address.pincode}
                                onChange={(event) => handlePersonalAddressChange(event, index)}
                                style={{ minHeight: '44px' }}
                                fullWidth
                              />
                            </Grid>
                          </React.Fragment>
                        ))}
                      </Grid>
                    </div>
                    <div style={{ display: 'flex', marginBottom: "-30px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: "-10px" }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <MKAvatar className="mk-avatar" style={{ cursor: 'pointer' }} src={add} alt="sm" size="sm" onClick={handleAddAddress} />
                        <Typography variant='h6' className="add-text">&nbsp;Add More Branch Address</Typography>
                      </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-40px", marginBottom: "10px" }}>
                      {personalAddress.some(address => Object.values(address).some(value => value && value !== address.trainingCompanyProfileID)) ? (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleBranchAddressNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled >
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleBranchAddressSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
                {currentStep === 6 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Company's Information</Typography>
                    <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                      <div>
                        <TextField
                          label="Service Tax Number (Eg.GST)"
                          variant="outlined"
                          style={{ width: "350px", borderColor: GSTNumberError ? 'red' : undefined }}
                          onChange={(e) => {
                            setGSTNumber(e.target.value);
                            handleGSTNumberChange(e, setGSTNumberError);
                          }}
                          error={!GSTNumberError}
                          value={GSTNumber}
                          fullWidth
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '30px', margin: '20px 0' }}>
                      <div>
                        <TextField
                          label="Tax Number (Eg.Pan)"
                          variant="outlined"
                          style={{ width: "350px", borderColor: panNumberError ? 'red' : undefined }}
                          onChange={(e) => {
                            setPanNumber(e.target.value);
                            handlePanNumberChange(e, setPanNumberError);
                          }}
                          error={!panNumberError}
                          value={panNumber}
                          fullWidth
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '30px', margin: '20px 0' }}>
                      <div>
                        <TextField
                          label="Payment Terms (in Days)"
                          variant="outlined"
                          style={{ width: "350px", borderColor: paymentTermsError ? 'red' : undefined }}
                          onChange={(e) => {
                            setPaymentTerms(e.target.value);
                            handlePaymentTermsChange(e, setPaymentTermsError);
                          }}
                          error={!paymentTermsError}
                          value={paymentTerms}
                          fullWidth
                        />
                      </div>
                    </div>
                    <div style={{ display: 'flex', marginBottom: "-30px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-40px", marginBottom: "10px" }}>
                      {(!paymentTerms && !panNumber && !GSTNumber) || (!GSTNumberError || !panNumberError || !paymentTermsError) ? (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleCompanyInfoSkipClick}>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      ) : (
                        <>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} onClick={handleCompanyInfoNextClick}>
                              NEXT
                            </MKButton>
                          </div>
                          <div>
                            <MKButton variant="gradient" color="info" style={{ margin: "0 10px" }} disabled>
                              SKIP
                            </MKButton>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
                {currentStep === 7 && (
                  <div>
                    <Typography style={{ marginBottom: "10px" }}>Social Media</Typography>
                    <div>
                      <div style={{ display: 'flex' }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Share your Social Media Url Informations</span> }]} />
                        </Grid>
                      </div>
                      {socialMediaPlatforms.map((platform) => (
                        <div key={platform.name} style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                          <div>
                            <TextField
                              label={`${platform.label} Url`}
                              variant="outlined"
                              style={{ width: '520px' }}
                              fullWidth
                              value={socialMediaUrls[platform.name]}
                              onChange={(e) => handleSocialMediaUrlChange(platform.name, e.target.value)}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{ display: 'flex', marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={handleBackClick}>BACK</MKButton>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-40px", marginBottom: "10px" }}>
                      <MKButton variant="gradient" color="info" onClick={onSubmitClick}>SUBMIT</MKButton>
                    </div>
                  </div>
                )}
              </Grid>
            </Grid>
          </Container>
        </Card>
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
            <SimpleFooter />
          </MKBox>
        </div>
      </LoadingOverlay>
    </>
  );
}

export default Page;